import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton } from 'investira.react.components';

/**
 * Renderiza o componente BackIconButton.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {number} props.size - Tamanho aplicado ao componente ou ícone.
 * @param {string} props.color - Cor usada na renderização do componente.
 * @param {Function} props.onClick - Callback executado ao clicar no componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const BackIconButton = memo(props => {
    const { onClick, size, color } = props;

    return (
        <IconButton onClick={onClick}>
            <Icon iconName="arrow-previous" size={size} color={color} />
        </IconButton>
    );
});

BackIconButton.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    onClick: PropTypes.func
};

BackIconButton.defaultProps = {
    size: 22,
    color: 'primary'
};

export default BackIconButton;
